export default __webpack_public_path__ + "static/aki-rose-braun-85013db14d72729707e5f52a807ec4cc.jpg";